import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-initial',
  imports: [],
  templateUrl: './user-initial.html',
  styleUrl: './user-initial.scss',
})
export class UserInitial {
  @Input() name: string | null = null;

  get initial(): string {
    return this.name ? this.name.charAt(0).toUpperCase() : '';
  }
}
